export default __webpack_public_path__ + "static/1411-0e7771e01ad857743d447d01951ae548.gif";